import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import React from 'react'
import {
  Input,
  Modal,
  Table as TableCortex,
  Td,
  THead,
  TRow
} from '@tecsinapse/cortex-react'
import { IoClose } from 'react-icons/io5'
import { Table } from '@/core/components/index'
import { rowsPerPageOptions } from '@/core/utils/rows-per-page'
import { EmptyList } from '@/core/components/empty-list'
import {
  useDialogByGruposUsuarios,
  UseDialogByGruposUsuariosProps
} from '../hooks/use-dialog-by-grupos-usuarios'
import { LoadingCards } from '@/core/components/loading-cards'
import { useModalOverflowHidden } from '@/core/hooks/use-modal-overflow-hidden'
import { FieldValues } from 'react-hook-form'

interface UsuarioDialogByGruposUsuariosProps
  extends UseDialogByGruposUsuariosProps<FieldValues> {
  abrir: boolean
  setAbrir: (open: boolean) => void
  mensagem?: string
}

export const UsuarioDialogByGruposUsuarios = ({
  idsGrupos,
  idsUsuariosNaoSelecionados,
  abrir,
  setAbrir,
  values,
  setValue,
  selection,
  mensagem,
  nameUsuariosRemovidos,
  isEdit
}: UsuarioDialogByGruposUsuariosProps) => {
  const { rowsSelectedLength, loading, table, setSearchText, totalElements } =
    useDialogByGruposUsuarios({
      values,
      setValue,
      nameUsuariosRemovidos,
      idsGrupos,
      idsUsuariosNaoSelecionados,
      selection,
      isEdit
    })
  useModalOverflowHidden({ open: abrir })

  return (
    <Modal
      open={abrir}
      onClose={() => setAbrir(false)}
      className='flex flex-col gap-y-deca w-[50%] max-h-[80%] overflow-y-scroll'
    >
      <div onClick={() => setAbrir(false)} className='self-end'>
        <IoClose
          className='self-end mb-micro hover:cursor-pointer text-secondary-xdark'
          size={30}
        />
      </div>

      <Input.Search
        onChange={e => {
          setSearchText(e.target.value)
        }}
        placeholder={t`Pesquisar por nome ou email`}
        className='w-[50%]'
      />

      {totalElements > 0 && mensagem && (
        <p className='text-secondary-medium text-sub'>{mensagem}</p>
      )}
      <>
        {totalElements === 0 && !loading ? (
          <EmptyList />
        ) : (
          <div className={'flex flex-1 items-center'}>
            {loading ? (
              <div className='w-full h-[38rem]'>
                <LoadingCards />
              </div>
            ) : (
              <div className={'flex flex-col w-full'}>
                <TableCortex className='overflow-y-scroll'>
                  <THead>
                    <TRow>
                      <Td colSpan={99} className='py-centi'>
                        <div className='flex w-full flex-row items-center justify-between'>
                          <p className='text-h3 font-bold'>
                            {selection ? (
                              <p className='text-h5 font-bold'>
                                <Trans>
                                  Usuários selecionados: {rowsSelectedLength}
                                </Trans>
                              </p>
                            ) : (
                              <p className='text-h5 font-bold'>
                                <Trans>Usuários</Trans>
                              </p>
                            )}
                          </p>
                        </div>
                      </Td>
                    </TRow>
                  </THead>
                  <Table.HeaderColumns table={table} />
                  <Table.Body table={table} />
                  <Table.Footer
                    table={table}
                    rowsPerPageOptions={rowsPerPageOptions}
                    loading={loading}
                    countList={totalElements}
                  />
                </TableCortex>
              </div>
            )}
          </div>
        )}
      </>
    </Modal>
  )
}
